<template>
  <b-container fluid class="header">
    <b-row>
      <b-col class="npd">
        <!-- <img
            src="@/assets/rebrand/snkrhud-header.svg"
            alt="snkrhud header"
            class="img-snkrheader"
          />

          <img src="@/assets/rebrand/header-text.svg" alt="snkrhud header" class="img-headertext" />
           -->
        <div class="video-container">
          <video playsinline ref="myvideo" poster="../../assets/rebrand/home/poster.png">
            <source
              src="https://d236khox6nm91.cloudfront.net/videos/Snkrhud%2BPLOT%2BTEASER%2B02.mp4"
              type="video/mp4"
            />
            Your browser does not support HTML5 video.
          </video>

          <div class="play-button">
            <button :disabled="isPlaying" @click="play" class="play">Play</button>
            <button :disabled="!isPlaying" @click="stop" class="pause">Stop</button>
          </div>
        </div>
        <!-- <video-player
            class="video-player-box"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
          >
          </video-player> -->
        <div class="btn-container">
          <b-link class="btn-gettingstarted" to="/getting-started">Getting Started</b-link>
          <b-link href="https://discord.gg/snkrhud" target="_blank" class="btn-join-now"></b-link>
          <b-link
            class="btn-whitepaper"
            href="https://docsend.com/view/9undhntua5fz2nsc"
            target="_blank"
            >Whitepaper</b-link
          >
        </div>
      </b-col>
      <img src="@/assets/rebrand/home/img-header-1.png" alt="header element" class="img-header-1" />
      <!-- <img src="@/assets/rebrand/header-banner.png" alt="header banner" class="img-banner" /> -->
      <img
        src="@/assets/rebrand/home/img-header-2.png"
        alt="header element"
        class="img-header-2 -wb"
      />
      <img src="@/assets/mobile/img-header-2.png" alt="header element" class="img-header-2  -mb" />
      <div class="bg-header" />
    </b-row>
  </b-container>
</template>
<script>
import 'video.js/dist/video-js.css';
// import { videoPlayer } from "vue-video-player";

export default {
  name: 'Hero',
  data() {
    return {
      isPlaying: false,
    };
  },
  methods: {
    play() {
      this.$refs.myvideo.play();
      this.isPlaying = true;
    },
    stop() {
      this.$refs.myvideo.pause();
      this.isPlaying = false;
    },
  },
};
</script>
<style lang="scss">
.play-button {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    button {
      display: block !important;
    }
  }
  button {
    color: transparent !important;

    cursor: pointer;
    &.play {
      border: 0 !important;
      background-color: none !important;
      background: url("../../assets/rebrand/home/btn-play.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 9vw;
      width: 9vw;
      object-fit: contain !important;
      cursor: pointer;
    }
    &.pause {
      border: 0 !important;
      background: transparent;
      // background-size: 9vw 9vw;
      background-repeat: no-repeat;
      height: 100%;
      width: 100%;
      object-fit: contain !important;
      cursor: pointer;
      display: none;
      background-color: #00000080;
    }
    &:disabled {
      display: none !important;
    }
  }
}
</style>
